import React from "react";
import "./Utility.css";

// Importing icons from React Icons
import { FaDragon, FaUsers, FaLock } from "react-icons/fa";

export default function Tokenomics() {
  return (
    <div className="main_transcaion_page">
      <div className="container">
        <div
          className="row trans_sc pt-5"
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine"
        >
          <div className="col-12 text-center">
            <div className="HeadingFont mb-4">
              <h1 style={{ fontSize: "40px", fontWeight:"600" }}>IP Tokenomics</h1>
            </div>
          </div>

          <p className="text-white ss">
            The IP Token is designed to drive the success of the Intelligence Project. Below is the breakdown of the token distribution and allocation to fuel the growth and sustainability of the ecosystem.
          </p>

          <div className="row justify-content-center">
            {/* Card 1 - Tokenomics Overview */}
            <div className="col-md-6 mb-4">
              <div className="trns_box_content text-start">
                <div className="icon_container text-center mb-3">
                  <FaDragon size={50} color="white" />
                </div>
                <h6 className="box-head">💰 Total Supply: 1,000,000,000 Tokens</h6>
                <p className="mt-3 ss">
                  The total supply of IP Token is 1,000,000,000 tokens, designed to fuel the growth of the project while ensuring fair distribution and sustainability. Burning will be cosidered on the roadmap to adjust ecosystem.
                </p>
                {/* <p className="mt-3 ss">
                  Token Contract: 0x9517Ca8c05F6d723796B896eEBA417d9c9Fe9999
                </p> */}
              </div>
            </div>

            {/* Card 2 - Distribution */}
            <div className="col-md-3 mb-4">
              <div className="trns_box_content text-start">
                <div className="icon_container text-center mb-3">
                  <FaLock size={50} color="white" />
                </div>
                <h6 className="box-head">📊 Token Distribution</h6>
                <p className="mt-3 ss">
                  <strong>Presale:</strong> 30%<br />
                  <strong>Staking:</strong> 10%<br />
                  <strong>Liquidity:</strong> 20%<br />
                  <strong>Marketing:</strong> 30%<br />
                  <strong>Project Funds:</strong> 10%
                </p>
              </div>
            </div>

            {/* Card 3 - Staking Mechanism */}
            <div className="col-md-3 mb-4">
              <div className="trns_box_content text-start">
                <div className="icon_container text-center mb-3">
                  <FaUsers size={50} color="white" />
                </div>
                <h6 className="box-head">🔒 Staking & Rewards</h6>
                <p className="mt-3 ss">
                  Participate in staking to earn passive rewards. Token holders can stake their IP Tokens to receive additional tokens, enhancing the ecosystem's liquidity and growth.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
